import { apiService } from './apiService';

export const uiMetadataService = {
  async getModuleForm(moduleKey: string) {
    return await apiService.get(`/ui-metadata/${moduleKey}/form`);
  },

  async saveModuleForm(moduleKey: string, data: any) {
    return await apiService.put(`/ui-metadata/${moduleKey}/form`, data);
  },

  async getModuleTable(moduleKey: string) {
    return await apiService.get(`/ui-metadata/${moduleKey}/table`);
  },

  async saveModuleTable(moduleKey: string, data: any) {
    return await apiService.put(`/ui-metadata/${moduleKey}/table`, data);
  },

  async getSupplyForm() {
    return await apiService.get('/ui-metadata/supply/form');
  },

  async saveSupplyForm(data: any) {
    return await apiService.put('/ui-metadata/supply/form', data);
  },

  async getSupplyTable() {
    return await apiService.get('/ui-metadata/supply/table');
  },

  async saveSupplyTable(data: any) {
    return await apiService.put('/ui-metadata/supply/table', data);
  },

  async searchLinkedRecords(moduleKey: string, q: string) {
    return await apiService.get(`/ui-metadata/linked-records?moduleKey=${encodeURIComponent(moduleKey)}&q=${encodeURIComponent(q)}`);
  },
};
